export enum API_LAYER_ENDPOINTS {
    MODELS = 'stock/get-models',
    VEHICLES = 'stock/get-vehicles',
    DEAL = 'configuration/stock',
    AVAILABILITY = 'stock/availability',
    SPC_LAYER = 'spc-layer',
    TRIM_SLUG = 'trim-slug',
}
